export default __webpack_public_path__ + "static/media/jobs-hero-img.a34efa7c.svg";